import { gaDataLayerEvent } from "../../plugins/analytics";
import { gtmEventName } from "@/plugins/gtmAnalytics";


export function trackPageLoadTime(pageName, callback) {
    requestAnimationFrame(() => {
      const navStart = parseFloat(sessionStorage.getItem('__PAGE_NAV_START__'));
      if (!isNaN(navStart)) {
        const visualReadyTime = performance.now() - navStart;
  
        // Trigger your dataLayer event
        gaDataLayerEvent(gtmEventName.C_Landing_Page_Load_Time, `${pageName} load in ${visualReadyTime.toFixed(2)}`);
  
        sessionStorage.removeItem('__PAGE_NAV_START__');
        if (typeof callback === 'function') callback(visualReadyTime);
      } else {
        console.log(`landing page load time already reported`);
      }
    });
  }
  